import { useSyncStore } from "../../store/syncStore";

export function SyncDot() {
  const status = useSyncStore((s) => s.status);
  const pending = useSyncStore((s) => s.pendingCount);
  let cls = "sync-dot";
  if (status === "syncing") cls += " syncing";
  else if (status === "error") cls += " error";
  else if (status === "offline") cls += " pending";
  else if (pending > 0) cls += " pending";
  else cls += " online";

  const title =
    status === "syncing"
      ? "Syncing…"
      : status === "error"
        ? "Sync error"
        : status === "offline"
          ? "Offline"
          : pending > 0
            ? `${pending} pending`
            : "Synced";

  return (
    <span
      className={cls}
      title={title}
      aria-label={title}
      data-testid="sync-dot"
    />
  );
}
